/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  TbArrowBigUpLine,
  TbArrowBigUpLineFilled,
  TbArrowBigDownLine,
  TbArrowBigDownLineFilled,
} from 'react-icons/tb';
import { asyncDownVoteComment, asyncUpVoteComment } from '../states/commentVotes/action';

function CommentVotes({
  id, upVotesBy, downVotesBy, authUser,
}) {
  const { threadId: thread_id } = useParams();
  const dispatch = useDispatch();
  const isCommentUpVoted = () => upVotesBy.includes(authUser.id);
  const isCommentDownVoted = () => downVotesBy.includes(authUser.id);

  const onUpVoteComment = ({ threadId, commentId }) => {
    dispatch(asyncUpVoteComment({ threadId, commentId }));
  };

  const onDownVoteComment = ({ threadId, commentId }) => {
    dispatch(asyncDownVoteComment({ threadId, commentId }));
  };

  return (
    <section className="votes">
      <div className="thread-detail__icon">
        <button className="vote-button" type="button" aria-label="up-vote" onClick={(event) => onUpVoteComment({ threadId: thread_id, commentId: id })}>
          { isCommentUpVoted() ? (
            <TbArrowBigUpLineFilled style={{ color: '#3B6E03' }} />
          ) : <TbArrowBigUpLine />}
        </button>
        <span>
          {upVotesBy.length}
        </span>
      </div>
      <div className="thread-detail__icon">
        <button className="vote-button" type="button" aria-label="down-vote" onClick={() => onDownVoteComment({ threadId: thread_id, commentId: id })}>
          { isCommentDownVoted() ? (
            <TbArrowBigDownLineFilled
              style={{ color: '#3B6E03' }}
            />
          ) : <TbArrowBigDownLine />}
        </button>
        <span>
          {downVotesBy.length}
        </span>
      </div>
    </section>
  );
}

const userShape = {
  id: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  avatar: PropTypes.string,
};

const commentItemShape = {
  id: PropTypes.string,
  upVotesBy: PropTypes.arrayOf(PropTypes.string).isRequired,
  downVotesBy: PropTypes.arrayOf(PropTypes.string).isRequired,
  authUser: PropTypes.shape(userShape).isRequired,
};

CommentVotes.propTypes = {
  ...commentItemShape,
};

export default CommentVotes;
